<template>
	<div id="PriceFilter">
		<h3>Filter</h3>
	</div>
</template>

<script>
	export default {
		name: "PriceFilter"
	}
</script>

<style scoped>

</style>
